module.exports = __webpack_public_path__ + "img/head.462d4802.svg";